<template>
  <div>
    <div id="content" class="content" style="margin-left:0px;">
      <h1 class="page-header" style="text-align:left">
        系统设置
        <small>/&nbsp;仓库管理</small>
      </h1>

      <div
        id="page-container"
        class="in page-sidebar-fixed page-header-fixed"
        style="padding-top:0px;"
      >
        <!-- begin #content -->
        <div
          id="content"
          class="content"
          style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
        >
          <!-- begin breadcrumb -->

          <div class="row">
            <!-- begin col-10 -->
            <div class="col-lg-12">
              <!-- begin panel -->
              <div class="panel panel-inverse">
                <!-- begin panel-heading -->
                <div class="panel-heading">
                  <div class="panel-heading-btn">
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-default"
                      data-click="panel-expand"
                    >
                      <i class="fa fa-expand"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-success"
                      data-click="panel-reload"
                    >
                      <i class="fa fa-redo"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-warning"
                      data-click="panel-collapse"
                    >
                      <i class="fa fa-minus"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-danger"
                      data-click="panel-remove"
                    >
                      <i class="fa fa-times"></i>
                    </a>
                  </div>
                  <h4 class="panel-title panelTitle">仓库管理列表</h4>
                </div>
                <!-- end panel-heading -->
                <!-- begin panel-body -->
                <div class="panel-body">
                  <form
                  
                    style="margin-top:16px;padding-left:15px;"
                  >
                    <fieldset>
                      <div class="form-group row m-b-15">
                        <label class="col-md-1 col-form-label">仓库编号</label>
                        <div class="col-md-2">
                          <input type="text" class="form-control" placeholder="仓库编号" v-model="mmsWareId">
                        </div>
                        <label class="col-md-1 col-form-label">仓库名称</label>
                        <div class="col-md-2">
                          <v-selectpage :data="SrcOptions" key-field="name" show-field="name" v-model="srcName" placeholder="请选择仓库名称" title=""></v-selectpage>
                        </div>
                        <div class="col-md-1">
                          <a class="btn btn-primary ButtonColor m-r-5" @click="SearchClick()" style="float:right;">查询</a>
                        </div>
                      </div>
                    </fieldset>
                  </form>
                  <!-- <div style="text-align:right;margin-bottom:20px;">
                    <a
                      class="btn btn-primary ButtonColor"
                      @click="AddClick()"
                    >新增</a>
                  </div> -->
                  <el-table :data="WarehouseList" border style="width: 100%">
                    <el-table-column prop="ordernumber" label="序号"  width="60" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="mmsWareId" label="仓库编号" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="name" label="仓库名称" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="srcTypeName" label="仓库类型" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="operator" label="创建人" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="inputTime" label="创建时间" align="center" show-overflow-tooltip></el-table-column>
                    <!-- <el-table-column label="操作" width="200" align="center" fixed="right">
                      <template slot-scope="scope">
                        <a class="btn btn-primary btn-sm ButtonColor" data-toggle="modal" @click="EditClick(scope.row)">编辑</a>
                        <a class="btn btn-warning btn-sm ButtonColor" @click="DeleteClick(scope.row)">删除</a>
                      </template>
                    </el-table-column> -->
                  </el-table>
                  <div class="PaginationStyle">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="pageindex"
                      :page-sizes="[10,20,50,100]"
                      :page-size="pageSize"
                      layout="total, sizes, prev, pager, next, jumper"
                      background
                      :total="totalCount"
                    ></el-pagination>
                  </div>
                </div>
                <!-- end panel-body -->
              </div>
              <!-- end panel -->
            </div>
            <!-- end col-10 -->
          </div>
          <!-- end row -->
        </div>
        <!-- end #content -->
      </div>
      <el-dialog title :visible.sync="outerVisible" width="500px" >
        <div v-if="EditDialog === 2" class="ModelPadding">
          <div class="swal-icon swal-icon--info"></div>
          <div class="swal-title">您确定删除吗?</div>
          <div class="swal-text" style="text-align:center">您将无法恢复这个文件!</div>
          <div class="swal-footer">
            <div class="swal-button-container">
              <button class="swal-button swal-button--confirm btn btn-primary" @click="MakeSure" :disabled = 'disabled'>确定</button>
            </div>
            <div class="swal-button-container">
              <div
                class="swal-button swal-button--cancel btn btn-default"
                @click="outerVisible = false"
              >取消</div>
            </div>
          </div>
        </div>
        <div v-if="EditDialog === 1" class="ModelPadding">
          <div class="swal-title" style="margin-top:0px">{{DialogTitle}}</div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="150px"
            class="demo-ruleForm"
            style="width:90%"
          >
            <el-form-item 
              label="仓库编号" 
              prop="mmsWareId" 
              :rules="[
                { required: true, message: '仓库编号不能为空'},
                { type: 'number', message: '仓库编号必须为数字值'}
              ]"
            >
              <el-input v-model.number="ruleForm.mmsWareId"></el-input>
            </el-form-item>
            <el-form-item label="仓库名称" prop="name" :rules="[{ required: true, message: '仓库名称不能为空'}]">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="仓库类型" prop="srcType">
              <el-select v-model="ruleForm.srcType" placeholder="请选择">
                <el-option
                  v-for="item in SrcTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="swal-footer"> 
            <div class="swal-button-container">
              <button
                class="swal-button swal-button--confirm btn btn-primary"
                @click="MakeSureEdit('ruleForm')"
                :disabled="disabled"
              >确定</button>
            </div>
            <div class="swal-button-container">
              <div
                class="swal-button swal-button--cancel btn btn-default"
                @click="outerVisible = false"
              >取消</div>
            </div>
          
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
  
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
export default {
  name: "BrandManagement",
  data() {
    return {
      pageSize: 10,
      totalCount: 0,
      pageindex: 1,
      outerVisible: false,
      DialogTitle: '',
      EditDialog: 1,
      CurrentSelection: [],
      disabled: false,
      mmsWareId:'',
      srcName: "",
      WarehouseList: [],
      SrcOptions:[],
      ruleForm: {},
      SrcTypes:[
        {
          label:'保税',
          value:1
        },
        {
          label:'直邮',
          value:2
        },
        {
          label:'一般贸易',
          value:3
        }
      ],
      rules: {}
    };
  },
  mounted: function() {
    this.initdata();
    this.getSrcList();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },
    EditClick(row) {
      this.outerVisible = true;
      this.DialogTitle = "编辑";
      this.EditDialog = 1;
      if(this.$refs['ruleForm']){
         this.$refs['ruleForm'].resetFields();
      }  
      this.ruleForm = MethodsBus.cloneRow(row);
    },
    DeleteClick(item) {
      this.outerVisible = true;
      this.EditDialog = 2;
      this.CurrentSelection = item;
    },
    AddClick() {
      if(this.$refs['ruleForm']){
        this.$refs['ruleForm'].resetFields();
      }
      this.ruleForm = {};
      this.outerVisible = true;
      this.DialogTitle = "新增";
      this.EditDialog = 1;
    },
    SearchClick() {
      this.pageindex = 1;
      this.initdata();
    },
    MakeSureEdit(formName) {
      let that = this;
      if (that.DialogTitle === "编辑") {
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.disabled = true;
            const options = {
              url: "distribution/B2cWarehouseController/updateWarehouse",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                id: that.ruleForm.id,
                name: that.ruleForm.name,
                mmsWareId: that.ruleForm.mmsWareId,
                srcType: that.ruleForm.srcType
              })
            };
            axios(options).then(function(response) {
              that.disabled = false;
              if (response.data.code == 200) {
                that.outerVisible = false;
                that.initdata();
                that.$notify({
                  title: "成功",
                  message: "修改成功",
                  type: "success"
                });
              } else {
                that.outerVisible = true;
                http.handleEorrorCode(response,that);
              }
            })
            .catch(function(error) {
              that.outerVisible = false;
              that.disabled = false;
              http.handleHttpError(error, that);
            });
          } else {
            that.outerVisible = true;
          }
        });
      } else if (that.DialogTitle === "新增") {
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.disabled = true;
            const options = {
              url: "distribution/B2cWarehouseController/addWarehouse",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                name: that.ruleForm.name,
                mmsWareId: that.ruleForm.mmsWareId,
                srcType: that.ruleForm.srcType
              })
            };
            axios(options).then(function(response) {
              that.disabled = false;
              if (response.data.code == 200) {
                that.outerVisible = false;
                that.initdata();
                that.$notify({
                  title: "成功",
                  message: "新增成功",
                  type: "success"
                });
              } else {
                that.outerVisible = true;
                http.handleEorrorCode(response,that);
              }
            })
            .catch(function(error) {
              that.outerVisible = false;
              that.disabled = false;
              http.handleHttpError(error, that);
            });
          } else {
            that.outerVisible = true;
          }
        });
      }
    },
    MakeSure() {
      let that = this;
      that.disabled = true;
      const options = {
        url: "distribution/B2cWarehouseController/delWarehouse",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          id: that.CurrentSelection.id
        })
      };
      axios(options).then(function(response) {
        that.disabled = false;
        that.outerVisible = false;
        that.initdata();
        if (response.data.code == 200) {
          that.$notify({
            title: "成功",
            message: response.data.message,
            type: "success"
          });
        } else {
          http.handleEorrorCode(response,that);
        }
      })
       .catch((error) => {
          that.disabled = false;
          that.outerVisible = false;
          http.handleHttpError(error, that);
        });
    },
    initdata() {
     let that = this;
      const options = {
        url: "distribution/B2cWarehouseController/getAllWarehouse",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          mmsWareId: that.mmsWareId,
          name: that.srcName,
          pageSize: that.pageSize,
          pageIndex: that.pageindex
        })
      };
      axios(options).then(function(response) {
        if (response.data.code == 200) {
          for (var i in response.data.data.records) {
            response.data.data.records[i].ordernumber =
            Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1;
            if (response.data.data.records[i].srcType === 1) {
              response.data.data.records[i].srcTypeName = "保税";
            } else if (response.data.data.records[i].srcType === 2) {
              response.data.data.records[i].srcTypeName = "直邮";
            }else if(response.data.data.records[i].srcType === 3){
              response.data.data.records[i].srcTypeName = "一般贸易";
            }
          }
          that.totalCount = response.data.data.total;
          that.WarehouseList = response.data.data.records;
        } else {
          http.handleEorrorCode(response,that);
        }
      }).catch((error) => {
        http.handleHttpError(error, that);
      });
    },
    // 获取仓库名称
    getSrcList() {
      let that = this;
      const options = {
        url: "distribution/B2cWarehouseController/getAllWarehouseName",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
        })
      };
      axios(options).then(function(response) {
        if (response.data.code == 200) {
          that.SrcOptions = response.data.data;
        } else {
          http.handleEorrorCode(response,that);
        }
      })
       .catch((error) => {
          http.handleHttpError(error, that);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.InputWidth{
  width:202px;
}
</style>



// WEBPACK FOOTER //
// src/components/Settings/WarehouseInfo.vue